import { Link } from "react-router-dom";

const CalculateHeader = () => {
    return (
        <div className="bg-white rounded-lg">
            <div className="flex gap-2 border-b">
                {/* Active Button */}
                {/* <Link to='/calculatorcourier'>  <button className="px-4 py-2 text-sm text-gray-600 hover:text-black">
                    Village Delivery
                </button></Link> */}
                {/* Active Button */}
                <Link to='/calculatorcourier'>  <button className="px-4 py-2 text-sm font-semibold text-black bg-blue-100 rounded-t-md border-b-2 border-black">
                    India's Shipment
                </button></Link>

                {/* Inactive Button */}
                {/* <Link to='/foreignair'>  <button className="px-4 cursor-not-allowed py-2 text-sm text-gray-600 hover:text-black">
                    Global Shipment
                </button></Link> */}
                <button
                    disabled
                    className="px-4 py-2 text-sm text-gray-400 cursor-not-allowed rounded"
                >
                    Global Shipment
                </button>
            </div>
        </div>
    );
};

export default CalculateHeader;
